import { useState } from "react";
import Input from "../../component/common/Input";
import Button from "../../component/common/Button";
import { ReactComponent as LockIcon } from "../../assets/lock.svg";
import { ReactComponent as EmailIcon } from "../../assets/@.svg";
import httpServices from "../../services/httpServices";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";

const Schema = yup.object().shape({
  email: yup.string().email().required("Email is required"),
});

const ForgotPassword = () => {
  const [timeLeft, setTimeLeft] = useState(20);
  const [timerRunning, setTimerRunning] = useState(false);

  const startTimer = () => {
    if (!timerRunning) {
      setTimerRunning(true);
      const timerInterval = setInterval(() => {
        setTimeLeft((prevTimeLeft) => {
          if (prevTimeLeft === 0) {
            clearInterval(timerInterval);
            setTimerRunning(false);
            return 20;
          } else {
            return prevTimeLeft - 1;
          }
        });
      }, 1000);
    }
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(Schema),
    defaultValues: {
      email: "",
    },
  });

  const handleSendEmail = async (data) => {
    console.log("Data", data);
    startTimer();
    try {
      const { response } = await httpServices.post(`/users/send/link`, {
        emailId: data.email,
        redirectUrl: "http://localhost:3000/change-password",
      });

      if (response.status === 200) {
        console.log("Response", response.data?.link);
        toast.success("Email sent successfully");
      }
    } catch (error) {
      console.log("Error", error);
      toast.error("Something went wrong");
    }
  };

  const onError = (errors) => {
    console.log("Errors", errors);
  };
  return (
    <div className="flex items-center justify-center min-h-screen bg-white p-[10px] sm:p-10">
      <div className="card w-[491px]">
        <h1 className="heading">Reset Password 🔐</h1>
        <p className="paragraph w-[80%]">
          Enter the email associated with your account and we’ll send an email
          with instructions to reset your password.
        </p>
        <>
          <form onSubmit={handleSubmit(handleSendEmail, onError)}>
            <div className="mt-[20px] mb-[20px] sm:mb-[40px]">
              <Input
                name="email"
                {...register("email")}
                Icon={EmailIcon}
                label={"Email"}
                placeholder={"Email address"}
                onChange={(e) => {
                  clearErrors("email");
                }}
              />
              {errors.email?.message && (
                <p className="text-[#e4376b] leading-[25px] text-sm ">
                  {errors.email?.message}
                </p>
              )}
            </div>

            <Button
              type="submit"
              content="Send link"
              disabled={timerRunning}
              classes={`hover:bg-[#3872A5] duration-300 justify-center w-full ${
                timerRunning && "cursor-not-allowed"
              }`}
            />
          </form>
          {timerRunning && (
            <p className="text-[#120D26] leading-[25px] mt-[19px] text-sm text-center">
              Sent Password Reset link to your email. Re-send Instructions in{" "}
              <span className="text-[#42A5F5]">{timeLeft}</span>
            </p>
          )}
        </>
      </div>
    </div>
  );
};

export default ForgotPassword;
